import { render } from "./FormActionLabel.vue?vue&type=template&id=5703e254"
import script from "./FormActionLabel.vue?vue&type=script&lang=js"
export * from "./FormActionLabel.vue?vue&type=script&lang=js"

import exportComponent from "/home/omid_es327/Projects/erp/laravel/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"FormActionLabel.vue"]])

export default __exports__